export const AI_CHIPS_TITLE = "activation.setup.ai.chips.title";
